import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators, FormControl, NgForm } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { AuthProvider } from '../../providers/auth/auth';
import _ from 'lodash';
import { Subject } from 'rxjs';
import { AlertController, LoadingController } from 'ionic-angular';
import { UtilityProvider } from '../../providers/utility/utility';
import { DatabaseProvider } from '../../providers/database/database';
import { ShippingProvider } from '../../providers/shipping/shipping';
import moment from "moment";

@IonicPage()
@Component({
  selector: 'page-program-shipments',
  templateUrl: 'program-shipments.html',
})
export class ProgramShipmentsPage implements OnInit {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_id: string;
  program_name: string;
  patient: any;
  exportjson: any[] = [];

  userid: string;
  user_fullname: string;
  user: any;
  pharmacies: any[] = [];
  therapies: any[] = [];
  therapy: any;
  indications: any[] = [];
  doses: any[] = [];
  shipmentPanelStatus = false;
  existing = false;
  ship_id: string; 

  addeditShipmentForm: FormGroup; 

  displayedColumns = ['shipment_id', 'pharmacy.name', 'dose', 'therapy', 'drug_type', 'lot', 'quantity', 'ship_date', 'createdBy', 'createdAt', 'actions'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('formShipmentDirective') private formShipmentDirective: NgForm;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    private dbShipping: ShippingProvider,
    private db: DatabaseProvider,
    private fb: FormBuilder,
    public alertCtrl: AlertController,
    public utility: UtilityProvider,
    public loadingCtrl: LoadingController
    ) {
    this.createForm();

    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;
      this.userid = user.id;
      this.user_fullname = user.first_name + ' ' + user.last_name;
      this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };

      this.db
      .getPharmaciesByProgram(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((pharmacies) => {
        this.pharmacies = pharmacies;
      });

      this.db
      .getTherapyByProgram(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((therapies) => {
        this.therapies = therapies;
      });

      this.dbShipping
      .listShipments(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe(shipment => {
        this.createExport(shipment);
        this.dataSource = new MatTableDataSource(shipment);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    });
  }

  ngOnInit()  {
  }

  ngOnDestroy() {
    console.log('Leave shipment view and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  createForm()  {
    this.addeditShipmentForm = this.fb.group({
      'shipment_id': [null, [Validators.required]],
      'pharmacy': [null, [Validators.required]],
      'therapy': [null, [Validators.required]],
      'dose': [null, [Validators.required]],
      'drug_type': [null, [Validators.required]],
      'lot': [null, [Validators.required]],
      'quantity': [null, [Validators.required]],
      'ship_date': [null, [Validators.required]],
      'notes': [null]
    });
    this.addeditShipmentForm.controls['ship_date'].setValue(new Date());
  }

  public async onTherapyChange(name)  {
    return new Promise((resolve, reject) => {
      this.addeditShipmentForm.controls['dose'].setValue(null);
      if(name)  {
        name = name.trim()
        this.therapy = name;
        const therapy = this.therapies.filter(item => item.name === name);
        if(therapy.length > 0) {
          this.indications = therapy[0]['indications'];
          this.doses = therapy[0]['dispensing'];
        }
      } else {
        this.indications = [];
        this.doses = [];
      }
      resolve();
    });
  }

  getUniqueShipmentNumber()  {
    this.addeditShipmentForm.controls['shipment_id'].setValue('Retrieving...');
    let loading = this.loadingCtrl.create({
      content: "Creating new shipment id"
    });

    loading.present().then(_ => {
      this.db.getUniqueShipmentNumber(this.program_id).then(data => {
        const orderNumber = 'ACR-EIS' + this.utility.pad(data, 4, '0');
        this.addeditShipmentForm.controls['shipment_id'].setValue(orderNumber);
        loading.dismiss();
      })
      .catch((err) => {
        this.addeditShipmentForm.controls['shipment_id'].setValue(null);
        this.utility.presentToast('Unable to get new shipment id.  Please try again.')
        loading.dismiss();
      })
    });
  }

  save()  {
    const loading = this.loadingCtrl.create({});
    loading.present();
    let shipment = this.addeditShipmentForm.value;
    shipment = { ...shipment };
    if (!this.existing)  {
      this.dbShipping.addShipment(this.program_id, shipment, this.user).then(() => {
        this.utility.presentToast('The shipment entry was successfully saved');
        this.cancel();
        loading.dismiss();
      })
      .catch(err => {
        this.utility.presentToast('Unable to save the shipment entry: ' + err);
        loading.dismiss();
      });
    } else {
      shipment.id = this.ship_id;
      this.dbShipping.updateShipment(this.program_id, shipment, this.user).then(() => {
        this.utility.presentToast('The shipment entry was successfully updated');
        this.cancel();
        loading.dismiss();
      })
      .catch(err => {
        this.utility.presentToast('Unable to update the shipment entry: ' + err);
        loading.dismiss();
      });
    }
  }

  public objectComparisonFunction = function( option, value ) : boolean {
    if(option && value) return option.id === value.id;
    else return null;
  }

  edit(item) {
    this.ship_id = item.id;
    let newitem = { ...item };
    newitem.ship_date = new Date(newitem.ship_date);
    this.onTherapyChange(item.therapy);
    this.addeditShipmentForm.patchValue(newitem);
    this.shipmentPanelStatus = true;
    this.existing = true;
  }
  
  delete(item){
      let confirm = this.alertCtrl.create({
        title: "Delete Shipment",
        message: "Are you sure you want to delete this shipment?  If so, type 'delete' into the textbox to confirm",
        inputs: [
          {
            name: 'delete_text',
            placeholder: 'delete',
            type: 'text'
          }
        ],
        buttons: [
          {
            text: "Cancel",
            handler: () => {}
          },
          {
            text: "Delete Shipment",
            handler: data => {
              let delete_text = data.delete_text;
              if(delete_text === 'delete') {
            
                this.dbShipping.deleteShipment(this.program_id, item.id)
                .then(response => {
                  this.utility.presentToast('The shipment entry was successfully deleted');
                })
                .catch(err => {
                  this.utility.presentToast('The shipment entry could not be deleted');
                });
              } else {
                return;
              }
            }
          }
        ]
      });
      confirm.present();
      }


  cancel()  {
    this.shipmentPanelStatus = false;
    this.ship_id = null;
    this.existing = false;
    setTimeout(() => {
      this.formShipmentDirective.resetForm();
      this.addeditShipmentForm.reset();
    }, 0);
  }

  createExport(shipment) {
    shipment.forEach((p) => {
      let shipex = {
        'Shipment ID': null,
        'Therapy': null,
        'Dose - DIN': null,
        'Drug Type': null,
        'Lot Number': null,
        'Quantity': null,
        'Ship To Pharmacy': null,
        'Ship To Address': null,
        'Ship To City': null,
        'Ship To Province': null,
        'Ship To Postal Code': null,
        'Ship Date': null
      }
      Object.keys(p).forEach(key => {
        if (p[key]) {
          if (p[key].seconds)  {
            p[key] = this.utility.formatDate(p[key].toDate(),"DD-MMM-YY");
          }
          if (key === 'shipment_id') {
            shipex['Shipment ID'] = p[key];
          } else if (key === 'therapy') {
            shipex['Therapy'] = p[key]
          } else if (key === 'dose') {
            shipex['Dose - DIN'] = p[key]
          } else if (key === 'drug_type') {
            shipex['Drug Type'] = p[key]
          } else if (key === 'lot') {
            shipex['Lot Number'] = p[key]
          } else if (key === 'quantity') {
            shipex['Quantity'] = p[key]
          } else if (key === 'pharmacy') {
            shipex['Ship To Pharmacy'] = p[key].name
            shipex['Ship To Address'] = p[key].address
            shipex['Ship To City'] = p[key].city
            shipex['Ship To Province'] = p[key].province
            shipex['Ship To Postal Code'] = p[key].postal_code
          } else if (key === 'ship_date') {
            shipex['Ship Date'] = p[key]
          }
        }
      });
    this.exportjson.push(shipex);
    });
  }

  export() {
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(this.exportjson);
    workSheet['!autofilter'] = { ref: "A1:L1" };
    XLSX.utils.book_append_sheet(workBook, workSheet, 'Shipments'); // add the worksheet to the book
    XLSX.writeFile(workBook, moment().format('YYYY-MMM-DD-HHssA') + '-shipments.xlsx'); // initiate a file download in browser
  }
}



// WEBPACK FOOTER //
// ./src/pages/program-shipments/program-shipments.ts